import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { GithubProvider } from './components/context/context'; 
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode> 
    <Auth0Provider 
    domain = 'dev-8g0gy-mi.us.auth0.com'
    clientId = '5buff7e3bPoqKI53GTYscAifh5VXaQ4k'
    redirectUri = {window.location.origin}
    cacheLocation = 'localstorage'
    >
    <GithubProvider>
        <App />           
    </GithubProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
